import { Suspense } from "react";
import { useCheckoutTabsContext } from "../providers/CheckoutTabsProvider";

const CurrentCheckoutTab = () => {
  const { currentTab } = useCheckoutTabsContext();

  return (
    <Suspense fallback="loading...">
      <currentTab.component />
    </Suspense>
  );
};
export default CurrentCheckoutTab;
